import React, { useEffect, useState, useCallback, useRef } from 'react'
import {
    Container,
    Blade,
    DataGridTable,
    Toast as toast
} from 'components'
import { GridRowSelectionModel } from '@mui/x-data-grid'
import { carrierListTableColumns } from '../tagListTableData'
import styles from '../tagList.module.scss'
import strings from 'strings'
import { reportException } from 'tools/logs'
import { assignCarriersForTags, unassignCarriersForTags } from 'api'

const s = strings.TAG_MANAGEMENT
const t = strings.TABLE_DEFAULTS
interface ICarriersForTagsProps {
    open: boolean
    currentTag: any
    motorCarriersForTags: any
    isAssignedCarriers: boolean
    loading: boolean
    onClose: () => void
}

const CarriersForTags: React.FC<ICarriersForTagsProps> = (props: ICarriersForTagsProps) => {
    const { open, currentTag, motorCarriersForTags, isAssignedCarriers, loading, onClose } = props
    const [btnLoader, setBtnLoader] = useState(false)
    const [disableBtn, setDisableBtn] = useState(true)
    const selectedRowsRef = useRef<GridRowSelectionModel>([])

    useEffect(() => {
        setDisableBtn(selectedRowsRef.current.length === 0);
    }, []);

    const handleClose = () => {
        selectedRowsRef.current = []
        onClose()
    }

    const handleCheckboxSelection = (selections: GridRowSelectionModel) => {
        selectedRowsRef.current = selections
        setDisableBtn(selections.length === 0)
    };

    const handleAssignUnassign = useCallback((action: any, tagId: any, payload: any) => {
        setBtnLoader(true);
        action(tagId, payload)
            .then((response: any) => toast({ id: `tagManagementToast`, title: response?.message }))
            .catch((error: any) => {
                reportException(error)
            })
            .finally(() => {
                setBtnLoader(false);
                handleClose();
            });
    }, [])

    const onSubmit = () => {
        const payLoad = {
            carrierEnrollmentIds: selectedRowsRef.current
        }

        if (selectedRowsRef.current.length === 0) {
            console.error('No rows selected');
            return;
        }

        if (isAssignedCarriers) {
            handleAssignUnassign(unassignCarriersForTags, currentTag, payLoad)
        } else {
            handleAssignUnassign(assignCarriersForTags, currentTag, payLoad)
        }
    }

    const MotorCarriersBlade = () => (
      <Container className={styles.bladeBodyContainer}>
        <Container className={styles.resultsContainer} sx={{ mt: 1 }}>
          <DataGridTable
            loading={loading}
            data={motorCarriersForTags || []}
            columns={carrierListTableColumns.columns}
            columnVisibilityModel={{ carrierEnrollmentId: false }}
            getRowId={(row) => row.carrierEnrollmentId}
            showFilter={true}
            multiSearchFilter={false}
            showTitle={false}
            checkboxSelection={true}
            disableSelectionOnClick={false}
            reduceHeight={210}
            handleCheckboxSelection={handleCheckboxSelection}
            customSelectionModel={selectedRowsRef.current}
            isRowSelectable={(params) => {
                return !(
                  params.row?.dot === t.DASH_VALUE &&
                  params.row?.mc === t.DASH_VALUE &&
                  params.row?.scac === t.DASH_VALUE &&
                  params.row?.uuid === t.DASH_VALUE &&
                  params.row?.cuid === t.DASH_VALUE
                );
              }}
          />
        </Container>
      </Container>
    )

    return (
        <Blade
            open={open}
            title={isAssignedCarriers ? s.ASSIGNED_CARRIERS : s.AVAILABLE_CARRIERS}
            onClose={onClose}
            bodyNode={<MotorCarriersBlade/>}
            size={'lg'}
            footerBtns={{
                primary: {
                    id: "carriersForTagsBlade",
                    label: isAssignedCarriers ? s.UNASSIGN : s.ASSIGN,
                    onClick: onSubmit,
                    loading: btnLoader,
                    disabled: btnLoader || disableBtn,
                },
                secondary: {
                    id: "closeCarriersForTagsBlade",
                    label: 'Cancel',
                    variant: 'outlined',
                    onClick: handleClose
                },
            }}
        />
    )
}

export default CarriersForTags